/** @format */

import About from "./About.jpeg";
import SignIn from "./SIgnIn.jpeg";
import SignUp from "./SignUp.jpeg";

const Banners = { About, SignIn, SignUp };

export default Banners;
